module.exports = __webpack_public_path__ + "static/media/design_agency.de168d48.jpg";